import { t } from 'i18next';

export enum OverviewType {
  APPLICATIONS = 'APPLICATIONS',
  FILE_SYSTEMS = 'FILE_SYSTEMS',
  PKCS11_TOKENS = 'PKCS11_TOKENS',
  NETWORK_ANALYZER = 'NETWORK_ANALYZER',
}

export const getLabel = (type: OverviewType) => {
  switch (type) {
    case OverviewType.APPLICATIONS:
      return t('applications');
    case OverviewType.FILE_SYSTEMS:
      return t('fileSystems');
    case OverviewType.PKCS11_TOKENS:
      return t('PKCS11Tokens');
    case OverviewType.NETWORK_ANALYZER:
      return t('networkAnalyzer');
    default:
      return '';
  }
};

export const getTypeByIndex = (index: number) => {
  const values = [OverviewType.APPLICATIONS, OverviewType.FILE_SYSTEMS, OverviewType.PKCS11_TOKENS, OverviewType.NETWORK_ANALYZER];

  return values[index % values.length];
};
